
  var _styles = {
  "traffic-train-trip-recommend-container": {
    "position": "relative",
    "width": "10rem",
    "overflow": "hidden",
    "fontSize": 0,
    "fontFamily": "PingFangSC-Regular"
  },
  "hot-cities-title": {
    "fontSize": "0.4rem",
    "paddingLeft": "0.33333rem",
    "marginTop": "0.33333rem"
  },
  "hot-cities-list-container": {
    "display": "flex",
    "width": "10rem",
    "justifyContent": "space-between",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "padding": "0.33333rem",
    "fontSize": "0.66667rem"
  },
  "hot-city-route-list": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "width": "100%",
    "flexWrap": "wrap"
  },
  "hot-city-route-block": {
    "position": "relative",
    "width": "50%",
    "marginBottom": "0.16rem",
    "fontSize": "0.34667rem"
  },
  "hot-city-route-block-inner-container": {
    "position": "relative",
    "display": "flex",
    "height": "1.65333rem",
    "borderRadius": "0.13333rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "hot-city-route-block-info": {
    "flex": 4,
    "paddingLeft": "0.26667rem"
  },
  "hot-city-route-block-info-city": {
    "marginTop": "0.34667rem",
    "marginBottom": "0.12rem"
  },
  "hot-city-route-block-info-from-city": {
    "width": "1.04rem",
    "textAlign": "center"
  },
  "hot-city-route-block-info-to-city": {
    "width": "1.04rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  